import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { AuthService } from '../auth.service';

export interface ConsolidationDismantlePreview {
  consolidation_id: number;
  version: string;
  can_dismantle: boolean;
  blocking_reasons: string[];
  remove: { lading_uuid: string; reference: string; kind: string }[];
  keep: { lading_uuid: string; reference: string; kind: string }[];
  manifest_id: number;
}

@Injectable({ providedIn: 'root' })
export class ConsolidationDismantleService {
  private readonly url = '/api/consolidations/dismantle_consolidation.php';
  private readonly allowedEmails = new Set([
    'allan@ulaap.com', 'jdo@ulaap.com', 'wayne@ulaap.com', 'byron.chisholm@gmail.com'
  ]);
  readonly canDismantle$ = this.auth.currentUser$.pipe(
    map(user => !!user && this.allowedEmails.has(user.email.trim().toLowerCase()))
  );

  constructor(private http: HttpClient, private auth: AuthService) {}

  preview(consolidationId: number) {
    return this.http.get<{ ok: boolean; data: ConsolidationDismantlePreview }>(this.url, {
      params: { consolidation_id: consolidationId }
    }).pipe(map(response => response.data));
  }

  dismantle(preview: ConsolidationDismantlePreview) {
    return this.http.delete<{ ok: boolean; data: { preserved_originals: number } }>(this.url, {
      body: { consolidation_id: preview.consolidation_id, version: preview.version }
    });
  }
}
